import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { Box, Button, Divider } from '@mui/material';
import { Delete, Visibility } from '@mui/icons-material';

import { Rooftop } from '@libs/models';
import { useRooftopAdminSearchQuery } from '@carcareers/store';
import { useRooftop } from '@carcareers/hooks';
import { FormProvider, useDrawer } from '@carcareers/contexts';
import { DashboardPageContainer, Drawer, RooftopCreateForm, DataGridV2 as DataGrid } from '@carcareers/components';
import {
  ROOFTOP_ADMIN_INDEX_COLUMNS,
  ROOFTOP_ADMIN_INDEX_COLUMN_INITIAL_STATE,
  routes,
  useIsMobile,
  ROOFTOP_ADMIN_INDEX_COLUMNS_INITIAL_STATE_MOBILE,
} from '@carcareers/utils';

export const RooftopIndex: FC = () => {
  const navigate = useNavigate();
  const { setOpen } = useDrawer();
  const { deleteRooftop } = useRooftop();
  const search = useRooftopAdminSearchQuery;
  const isMobile = useIsMobile();

  const columns = [
    ...ROOFTOP_ADMIN_INDEX_COLUMNS,
    {
      field: 'actions',
      type: 'actions' as const,
      flex: 1,
      align: 'right' as const,
      headerAlign: 'right' as const,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          showInMenu
          key={`view-${params.row.id}`}
          label="View"
          icon={<Visibility />}
          onClick={() =>
            navigate(`/${routes.ADMIN_HOME}/${routes.ADMIN_ROOFTOPS_VIEW.replace(':id', params.row.id.toString())}`)
          }
        />,
        <GridActionsCellItem
          showInMenu
          key={`delete-${params.row.id}`}
          label="Delete"
          icon={<Delete color="error" />}
          onClick={() => deleteRooftop(params.row.id)}
        />,
      ],
    },
  ];

  return (
    <>
      <DashboardPageContainer>
        <DataGrid<Rooftop>
          query={search}
          columns={columns}
          tools={
            <>
              <Button onClick={() => setOpen(true)} variant="contained" color="primary">
                Add
              </Button>
              <Divider orientation="vertical" sx={{ height: 24, ml: 1 }} />
            </>
          }
          initialState={{
            columns: {
              columnVisibilityModel: isMobile
                ? ROOFTOP_ADMIN_INDEX_COLUMNS_INITIAL_STATE_MOBILE
                : ROOFTOP_ADMIN_INDEX_COLUMN_INITIAL_STATE,
            },
          }}
        />
      </DashboardPageContainer>
      <Drawer title="Add Rooftop" width={500}>
        <FormProvider>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%', p: 2 }}>
            <RooftopCreateForm />
          </Box>
        </FormProvider>
      </Drawer>
    </>
  );
};

export default RooftopIndex;
